import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { Toaster } from 'sonner'
import './index.css'
import App from './App'
import GlobalErrorBoundary from './components/GlobalErrorBoundary'
import { initWebVitals } from './utils/webVitals'

// Initialize Web Vitals performance monitoring
initWebVitals({
  debug: import.meta.env.DEV,
  // Uncomment to send metrics to an analytics endpoint:
  // analyticsEndpoint: '/api/vitals',
})

// Create a client with sensible defaults
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 1000 * 60 * 5, // 5 minutes
      refetchOnWindowFocus: false,
    },
  },
})

const rootElement = document.getElementById('root')

if (!rootElement) {
  throw new Error('Root element not found')
}

createRoot(rootElement).render(
  <StrictMode>
    <GlobalErrorBoundary>
      <QueryClientProvider client={queryClient}>
        <App />
        <Toaster position="top-right" richColors closeButton />
      </QueryClientProvider>
    </GlobalErrorBoundary>
  </StrictMode>,
)
